<div class="d-flex align-items-center" paceCoreValidationMessage [validation]="checkboxControl">
    <div [ngClass]="{ 'readonly-input-control': isReadonlyInputControl }" class="checkbox-container">
        <input
            type="checkbox"
            [formControl]="checkboxControl"
            class="form-control"
            [id]="checkBoxID"
            [attr.aria-label]="ariaLabel"
        />
        <fa-icon *ngIf="this.model.value" [icon]="faCheck" size="2x"></fa-icon>
    </div>
    <label *ngIf="model.options && model.options.showLabel" class="ms-2 mb-0" [for]="checkBoxID">{{
        model.displayName
    }}</label>
</div>
